import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { useApp, UserAvatar } from '@laboratoria/sdk-react';
import laboratoriaIcon from '@laboratoria/sdk-react/src/icons/laboratoria-isotipo.svg';


const UserMenu = ({ lang }) => {
  const { auth } = useApp();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!auth.user) {
    return (
      <Button
        size="large"
        color="secondary"
        component={Link}
        to={`/${lang}/auth/signin`}
        sx={{
          px: {
            xs: 5,
            sm: 9,
          },
        }}
      >
        <FormattedMessage id="top-bar/sign-in" />
      </Button>
    );
  }

  return (
    <>
      <IconButton onClick={handleMenu} data-testid="user-menu-button">
        <UserAvatar user={auth.user} />
      </IconButton>
      <Drawer
        anchor="right"
        open={Boolean(anchorEl)}
        onClick={() => setAnchorEl(null)}
        color="#FFE521"
        sx={{
          width: '250px',
          '& .MuiPaper-root': {
            backgroundColor: '#FFE521'
          },
        }}
      >
        <List sx={{ backgroundColor: '#FFE521' }}>
          <ListItem
            component={Link}
            to={`/${lang}/`}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <span className="hide-when-not-small">
              <img
                alt="Laboratoria logo"
                src={laboratoriaIcon}
                height={56}
              />
            </span>
          </ListItem>
        </List>
        <Divider sx={{ backgroundColor: '#000000' }} />
        <List
          sx={{
            width: '300px',
            a: { textDecoration: 'none', },
            fontSize: { xs: '0.75rem', sm: '1.125rem' },
            fontWeight: '600',
            backgroundColor: '#FFE521',
          }}>
          <ListItem component={Link} to={`/${lang}/account`}>
            <ListItemIcon>
              <UserAvatar authUser={auth.authUser} user={auth.user} />
            </ListItemIcon>
            <ListItemText primary={auth.user.fullName} secondary={auth.user.email} />
          </ListItem>
          <ListItem component={Link} to="#" data-testid={'signout-button'} onClick={() => {
            auth.signOut().then(handleClose);
          }}>
            <ListItemIcon><LockOpenIcon /></ListItemIcon>
            <FormattedMessage id="top-bar/sign-out" />
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};

export default UserMenu;
